import React from 'react';
import { Link } from 'react-router-dom';
import { renderStatusBadge } from '../../../Table/utils';
import PropTypes from 'prop-types';

const BadgeWithLinkedText = ({
    statusProperty,
    text,
    to
}) => (
    <>
        {renderStatusBadge(statusProperty)}
        <Link
            title={text}
            to={to}
        >
            {text}
        </Link>
    </>
);

BadgeWithLinkedText.propTypes = {
    statusProperty: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    to: PropTypes.object.isRequired,
};

BadgeWithLinkedText.defaultProps = {};

export default BadgeWithLinkedText;
